export const ROUTE_PATHS = Object.freeze({
  home: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  dashboard: '/dashboard',
  admin: '/admin',
  builder: '/builder',
  builderWithId: '/builder/:websiteId',
  siteViewer: '/site/:websiteId/*',
  onlineInvitations: '/online-pokani',
  fallback: '*',
});

